import { Component } from "@angular/core";
import { LABELS } from "../../../core/constants/label-constants";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatButton, MatIconButton } from "@angular/material/button";
import { MatCardContent } from "@angular/material/card";
import { CommonModule, NgForOf } from "@angular/common";
import {
  MatError,
  MatFormField,
  MatInput,
  MatLabel,
} from "@angular/material/input";
import { MatOption, MatSelect } from "@angular/material/select";
import { HelperService } from "../../../core/services/helper/helper.service";
import { ConfigService } from "../configuration/config.service";
import { CommonService } from "../common-service/common.service";
import { AccountService } from "../settings/account/account.service";
import { Router } from "@angular/router";
import { CommonConstants } from "app/core/constants/common-constants";

@Component({
  selector: "app-shipping-cost-matrix",
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatError,
    MatFormField,
    MatInput,
    MatLabel,
    MatSelect,
    MatOption,
    MatButton,
  ],
  templateUrl: "./shipping-cost-matrix.component.html",
  styleUrl: "./shipping-cost-matrix.component.scss",
})
export class ShippingCostMatrixComponent {
  ZONES: any = [
    { code: "A", name: "Domestic", shippingCharge: 1, minShippingDays: 1, maxShippingDays: 1 },
    { code: "B", name: "Close EU", shippingCharge: 2, minShippingDays: 1, maxShippingDays: 1 },
    { code: "C", name: "Peripheral EU", shippingCharge: 3, minShippingDays: 1, maxShippingDays: 1 },
    { code: "D", name: "UK", shippingCharge: 4, minShippingDays: 1, maxShippingDays: 1 },
    { code: "-", name: "Default", shippingCharge: 4, minShippingDays: 1, maxShippingDays: 1 },
  ];
  COUNTRY_ZONE_MATRIX: any = {
    Austria: { Austria: "A", Belgium: "B", Bulgaria: "B", Croatia: "B", Cyprus: "C", "Czech Republic": "B", Denmark: "B", Estonia: "C", Finland: "C", France: "B", Germany: "B", Greece: "B", Hungary: "B", Ireland: "C", Italy: "B", Latvia: "C", Lithuania: "C", Luxembourg: "B", Malta: "C", Netherlands: "B", Poland: "B", Portugal: "C", Romania: "B", Slovakia: "B", Slovenia: "B", Spain: "C", Sweden: "C", "United Kingdom": "D" },
    Belgium: { Austria: "B", Belgium: "A", Bulgaria: "C", Croatia: "B", Cyprus: "C", "Czech Republic": "B", Denmark: "B", Estonia: "C", Finland: "C", France: "B", Germany: "B", Greece: "C", Hungary: "B", Ireland: "B", Italy: "B", Latvia: "C", Lithuania: "C", Luxembourg: "B", Malta: "C", Netherlands: "B", Poland: "B", Portugal: "C", Romania: "C", Slovakia: "B", Slovenia: "B", Spain: "B", Sweden: "B", "United Kingdom": "D" },
    Bulgaria: { Austria: "B", Belgium: "C", Bulgaria: "A", Croatia: "B", Cyprus: "B", "Czech Republic": "B", Denmark: "C", Estonia: "C", Finland: "C", France: "C", Germany: "B", Greece: "B", Hungary: "B", Ireland: "C", Italy: "B", Latvia: "C", Lithuania: "C", Luxembourg: "C", Malta: "B", Netherlands: "C", Poland: "B", Portugal: "C", Romania: "B", Slovakia: "B", Slovenia: "B", Spain: "C", Sweden: "C", "United Kingdom": "D" },
    Croatia: { Austria: "B", Belgium: "B", Bulgaria: "B", Croatia: "A", Cyprus: "C", "Czech Republic": "B", Denmark: "B", Estonia: "C", Finland: "C", France: "B", Germany: "B", Greece: "B", Hungary: "B", Ireland: "C", Italy: "B", Latvia: "C", Lithuania: "C", Luxembourg: "B", Malta: "C", Netherlands: "B", Poland: "B", Portugal: "C", Romania: "B", Slovakia: "B", Slovenia: "B", Spain: "C", Sweden: "C", "United Kingdom": "D" },
    // Cyprus: { Austria: "C", Belgium: "C", Bulgaria: "B", Croatia: "C", Cyprus: "A", "Czech Republic": "C", Denmark: "C", Estonia: "C", Finland: "C", France: "C", Germany: "C", Greece: "B", Hungary: "C", Ireland: "C", Italy: "B", Latvia: "C", Lithuania: "C", Luxembourg: "C", Malta: "B", Netherlands: "C", Poland: "C", Portugal: "C", Romania: "B", Slovakia: "C", Slovenia: "C", Spain: "C", Sweden: "C", "United Kingdom": "D" },
    "Czech Republic": { Austria: "B", Belgium: "B", Bulgaria: "B", Croatia: "B", Cyprus: "C", "Czech Republic": "A", Denmark: "B", Estonia: "B", Finland: "C", France: "B", Germany: "B", Greece: "C", Hungary: "B", Ireland: "C", Italy: "B", Latvia: "B", Lithuania: "B", Luxembourg: "B", Malta: "C", Netherlands: "B", Poland: "B", Portugal: "C", Romania: "B", Slovakia: "B", Slovenia: "B", Spain: "C", Sweden: "B", "United Kingdom": "D" },
    Denmark: { Austria: "B", Belgium: "B", Bulgaria: "C", Croatia: "B", Cyprus: "C", "Czech Republic": "B", Denmark: "A", Estonia: "B", Finland: "B", France: "B", Germany: "B", Greece: "C", Hungary: "B", Ireland: "B", Italy: "C", Latvia: "B", Lithuania: "B", Luxembourg: "B", Malta: "C", Netherlands: "B", Poland: "B", Portugal: "C", Romania: "C", Slovakia: "B", Slovenia: "B", Spain: "C", Sweden: "B", "United Kingdom": "D" },
    Estonia: { Austria: "C", Belgium: "C", Bulgaria: "C", Croatia: "C", Cyprus: "C", "Czech Republic": "B", Denmark: "B", Estonia: "A", Finland: "B", France: "C", Germany: "B", Greece: "C", Hungary: "B", Ireland: "C", Italy: "C", Latvia: "B", Lithuania: "B", Luxembourg: "C", Malta: "C", Netherlands: "B", Poland: "B", Portugal: "C", Romania: "C", Slovakia: "B", Slovenia: "C", Spain: "C", Sweden: "B", "United Kingdom": "D" },
    Finland: { Austria: "C", Belgium: "C", Bulgaria: "C", Croatia: "C", Cyprus: "C", "Czech Republic": "C", Denmark: "B", Estonia: "B", Finland: "A", France: "C", Germany: "B", Greece: "C", Hungary: "C", Ireland: "C", Italy: "C", Latvia: "B", Lithuania: "B", Luxembourg: "C", Malta: "C", Netherlands: "B", Poland: "B", Portugal: "C", Romania: "C", Slovakia: "C", Slovenia: "C", Spain: "C", Sweden: "B", "United Kingdom": "D" },
    France: { Austria: "B", Belgium: "B", Bulgaria: "C", Croatia: "B", Cyprus: "C", "Czech Republic": "B", Denmark: "B", Estonia: "C", Finland: "C", France: "A", Germany: "B", Greece: "C", Hungary: "B", Ireland: "B", Italy: "B", Latvia: "C", Lithuania: "C", Luxembourg: "B", Malta: "C", Netherlands: "B", Poland: "B", Portugal: "B", Romania: "C", Slovakia: "B", Slovenia: "B", Spain: "B", Sweden: "C", "United Kingdom": "D" },
    Germany: { Austria: "B", Belgium: "B", Bulgaria: "B", Croatia: "B", Cyprus: "C", "Czech Republic": "B", Denmark: "B", Estonia: "B", Finland: "B", France: "B", Germany: "A", Greece: "C", Hungary: "B", Ireland: "C", Italy: "B", Latvia: "B", Lithuania: "B", Luxembourg: "B", Malta: "C", Netherlands: "B", Poland: "B", Portugal: "C", Romania: "B", Slovakia: "B", Slovenia: "B", Spain: "B", Sweden: "B", "United Kingdom": "D" },
    Greece: { Austria: "B", Belgium: "C", Bulgaria: "B", Croatia: "B", Cyprus: "B", "Czech Republic": "C", Denmark: "C", Estonia: "C", Finland: "C", France: "C", Germany: "C", Greece: "A", Hungary: "B", Ireland: "C", Italy: "B", Latvia: "C", Lithuania: "C", Luxembourg: "C", Malta: "B", Netherlands: "C", Poland: "C", Portugal: "C", Romania: "B", Slovakia: "B", Slovenia: "B", Spain: "C", Sweden: "C", "United Kingdom": "D" },
    Hungary: { Austria: "B", Belgium: "B", Bulgaria: "B", Croatia: "B", Cyprus: "C", "Czech Republic": "B", Denmark: "B", Estonia: "B", Finland: "C", France: "C", Germany: "B", Greece: "B", Hungary: "A", Ireland: "C", Italy: "B", Latvia: "B", Lithuania: "B", Luxembourg: "B", Malta: "C", Netherlands: "B", Poland: "B", Portugal: "C", Romania: "B", Slovakia: "B", Slovenia: "B", Spain: "C", Sweden: "C", "United Kingdom": "D" },
    Ireland: { Austria: "C", Belgium: "B", Bulgaria: "C", Croatia: "C", Cyprus: "C", "Czech Republic": "C", Denmark: "B", Estonia: "C", Finland: "C", France: "B", Germany: "C", Greece: "C", Hungary: "C", Ireland: "A", Italy: "C", Latvia: "C", Lithuania: "C", Luxembourg: "B", Malta: "C", Netherlands: "B", Poland: "C", Portugal: "C", Romania: "C", Slovakia: "C", Slovenia: "C", Spain: "B", Sweden: "C", "United Kingdom": "B" },
    Italy: { Austria: "B", Belgium: "B", Bulgaria: "B", Croatia: "B", Cyprus: "B", "Czech Republic": "B", Denmark: "C", Estonia: "C", Finland: "C", France: "B", Germany: "B", Greece: "B", Hungary: "B", Ireland: "C", Italy: "A", Latvia: "C", Lithuania: "C", Luxembourg: "B", Malta: "B", Netherlands: "B", Poland: "B", Portugal: "B", Romania: "B", Slovakia: "B", Slovenia: "B", Spain: "B", Sweden: "C", "United Kingdom": "D" },
    Latvia: { Austria: "C", Belgium: "C", Bulgaria: "C", Croatia: "C", Cyprus: "C", "Czech Republic": "B", Denmark: "B", Estonia: "B", Finland: "B", France: "C", Germany: "B", Greece: "C", Hungary: "B", Ireland: "C", Italy: "C", Latvia: "A", Lithuania: "B", Luxembourg: "C", Malta: "C", Netherlands: "B", Poland: "B", Portugal: "C", Romania: "B", Slovakia: "B", Slovenia: "C", Spain: "C", Sweden: "B", "United Kingdom": "D" },
    Lithuania: { Austria: "C", Belgium: "C", Bulgaria: "C", Croatia: "C", Cyprus: "C", "Czech Republic": "B", Denmark: "B", Estonia: "B", Finland: "B", France: "C", Germany: "B", Greece: "C", Hungary: "B", Ireland: "C", Italy: "C", Latvia: "B", Lithuania: "A", Luxembourg: "C", Malta: "C", Netherlands: "B", Poland: "B", Portugal: "C", Romania: "B", Slovakia: "B", Slovenia: "C", Spain: "C", Sweden: "B", "United Kingdom": "D" },
    Luxembourg: { Austria: "B", Belgium: "B", Bulgaria: "C", Croatia: "B", Cyprus: "C", "Czech Republic": "B", Denmark: "B", Estonia: "C", Finland: "C", France: "B", Germany: "B", Greece: "C", Hungary: "B", Ireland: "B", Italy: "B", Latvia: "C", Lithuania: "C", Luxembourg: "A", Malta: "C", Netherlands: "B", Poland: "B", Portugal: "C", Romania: "C", Slovakia: "B", Slovenia: "B", Spain: "B", Sweden: "C", "United Kingdom": "D" },
    // Malta: { Austria: "C", Belgium: "C", Bulgaria: "B", Croatia: "C", Cyprus: "B", "Czech Republic": "C", Denmark: "C", Estonia: "C", Finland: "C", France: "C", Germany: "C", Greece: "B", Hungary: "C", Ireland: "C", Italy: "B", Latvia: "C", Lithuania: "C", Luxembourg: "C", Malta: "A", Netherlands: "C", Poland: "C", Portugal: "C", Romania: "C", Slovakia: "C", Slovenia: "C", Spain: "B", Sweden: "C", "United Kingdom": "D" },
    Netherlands: { Austria: "B", Belgium: "B", Bulgaria: "C", Croatia: "B", Cyprus: "C", "Czech Republic": "B", Denmark: "B", Estonia: "B", Finland: "B", France: "B", Germany: "B", Greece: "C", Hungary: "B", Ireland: "B", Italy: "B", Latvia: "B", Lithuania: "B", Luxembourg: "B", Malta: "C", Netherlands: "A", Poland: "B", Portugal: "C", Romania: "C", Slovakia: "B", Slovenia: "B", Spain: "B", Sweden: "B", "United Kingdom": "D" },
    Poland: { Austria: "B", Belgium: "B", Bulgaria: "B", Croatia: "B", Cyprus: "C", "Czech Republic": "B", Denmark: "B", Estonia: "B", Finland: "B", France: "B", Germany: "B", Greece: "C", Hungary: "B", Ireland: "C", Italy: "B", Latvia: "B", Lithuania: "B", Luxembourg: "B", Malta: "C", Netherlands: "B", Poland: "A", Portugal: "C", Romania: "B", Slovakia: "B", Slovenia: "B", Spain: "C", Sweden: "B", "United Kingdom": "D" },
    Portugal: { Austria: "C", Belgium: "C", Bulgaria: "C", Croatia: "C", Cyprus: "C", "Czech Republic": "C", Denmark: "C", Estonia: "C", Finland: "C", France: "B", Germany: "C", Greece: "C", Hungary: "C", Ireland: "C", Italy: "B", Latvia: "C", Lithuania: "C", Luxembourg: "C", Malta: "C", Netherlands: "C", Poland: "C", Portugal: "A", Romania: "C", Slovakia: "C", Slovenia: "C", Spain: "B", Sweden: "C", "United Kingdom": "D" },
    Romania: { Austria: "B", Belgium: "C", Bulgaria: "B", Croatia: "B", Cyprus: "B", "Czech Republic": "B", Denmark: "C", Estonia: "C", Finland: "C", France: "C", Germany: "B", Greece: "B", Hungary: "B", Ireland: "C", Italy: "B", Latvia: "B", Lithuania: "B", Luxembourg: "C", Malta: "C", Netherlands: "C", Poland: "B", Portugal: "C", Romania: "A", Slovakia: "B", Slovenia: "B", Spain: "C", Sweden: "C", "United Kingdom": "D" },
    Slovakia: { Austria: "B", Belgium: "B", Bulgaria: "B", Croatia: "B", Cyprus: "C", "Czech Republic": "B", Denmark: "B", Estonia: "B", Finland: "C", France: "B", Germany: "B", Greece: "B", Hungary: "B", Ireland: "C", Italy: "B", Latvia: "B", Lithuania: "B", Luxembourg: "B", Malta: "C", Netherlands: "B", Poland: "B", Portugal: "C", Romania: "B", Slovakia: "A", Slovenia: "B", Spain: "C", Sweden: "C", "United Kingdom": "D" },
    Slovenia: { Austria: "B", Belgium: "B", Bulgaria: "B", Croatia: "B", Cyprus: "C", "Czech Republic": "B", Denmark: "B", Estonia: "C", Finland: "C", France: "B", Germany: "B", Greece: "B", Hungary: "B", Ireland: "C", Italy: "B", Latvia: "C", Lithuania: "C", Luxembourg: "B", Malta: "C", Netherlands: "B", Poland: "B", Portugal: "C", Romania: "B", Slovakia: "B", Slovenia: "A", Spain: "C", Sweden: "C", "United Kingdom": "D" },
    Spain: { Austria: "C", Belgium: "B", Bulgaria: "C", Croatia: "C", Cyprus: "C", "Czech Republic": "C", Denmark: "C", Estonia: "C", Finland: "C", France: "B", Germany: "B", Greece: "C", Hungary: "C", Ireland: "B", Italy: "B", Latvia: "C", Lithuania: "C", Luxembourg: "B", Malta: "B", Netherlands: "B", Poland: "C", Portugal: "B", Romania: "C", Slovakia: "C", Slovenia: "C", Spain: "A", Sweden: "C", "United Kingdom": "D" },
    Sweden: { Austria: "C", Belgium: "B", Bulgaria: "C", Croatia: "C", Cyprus: "C", "Czech Republic": "B", Denmark: "B", Estonia: "B", Finland: "B", France: "C", Germany: "B", Greece: "C", Hungary: "C", Ireland: "C", Italy: "C", Latvia: "B", Lithuania: "B", Luxembourg: "C", Malta: "C", Netherlands: "B", Poland: "B", Portugal: "C", Romania: "C", Slovakia: "C", Slovenia: "C", Spain: "C", Sweden: "A", "United Kingdom": "D" },
    "United Kingdom": { Austria: "D", Belgium: "D", Bulgaria: "D", Croatia: "D", Cyprus: "D", "Czech Republic": "D", Denmark: "D", Estonia: "D", Finland: "D", France: "D", Germany: "D", Greece: "D", Hungary: "D", Ireland: "B", Italy: "D", Latvia: "D", Lithuania: "D", Luxembourg: "D", Malta: "D", Netherlands: "D", Poland: "D", Portugal: "D", Romania: "D", Slovakia: "D", Slovenia: "D", Spain: "D", Sweden: "D", "United Kingdom": "A" }
  };
  countries = Object.keys(this.COUNTRY_ZONE_MATRIX);
  zoneForm: FormGroup;
  originDestinationForm: any;
  IMForm: FormGroup;
  isLoad: boolean = false;
  currencyList: any = [];
  isPartner: boolean = false;
  profileData: any;

  constructor(
    private fb: FormBuilder,
    public _helper: HelperService,
    private _configService: ConfigService,
    private _uploadService: CommonService,
    private _apiService: AccountService,
    private _router: Router
  ) {
    this.isPartner = this._router.url.indexOf('/partner') !== -1 || window.location.origin.indexOf('partners') !== -1;
    if (this._router.url.indexOf('/partner-management') !== -1) {
      this.isPartner = false;
    }
    this._helper.pageName.next(LABELS.SHIPPING_COST_MATRIX);
    this.zoneForm = this.fb.group({
      zones: this.fb.array(
        this.ZONES.map((zone: any) => this.createZoneForm(zone))
      ),
    });
    this.originDestinationForm = this.fb.group({});
    this.buildMatrixForm();
    this.IMForm = this.fb.group({
      items: this.fb.array([this.createIMFGroup(0)]),
    });
    if (this.isPartner) {
      this.getAccountDetails();
    } else {
      this.getData();
    }

    this.getCurrencyForList();

  }

  getAccountDetails() {
    this._apiService.viewAccount(this.isPartner).subscribe((res: any) => {
      if (res?.meta?.status == 1) {
        this.profileData = res?.data;
        const zonesArray = this.zonesFormArray;
        this.profileData?.zones?.forEach((zone: any, index: number) => {
          if (zonesArray.at(index)) {
            zonesArray.at(index).patchValue({
              shippingCharge: zone.shippingCharge,
              minShippingDays: zone.minShippingDays,
              maxShippingDays: zone.maxShippingDays,
              currency: zone.currency,
            });
          }
        });

        const matrixData = this.profileData?.originMatrixData ?? {};

        Object.keys(matrixData)?.forEach((origin: any) => {
          const originGroup = this.originDestinationForm?.get(
            origin
          ) as FormGroup;
          if (!originGroup) return;

          Object.keys(matrixData[origin])?.forEach((destination) => {
            if (originGroup?.get(destination)) {
              originGroup
                ?.get(destination)
                ?.patchValue(matrixData[origin][destination]);
            }
          });
        });

        this.IMFArray.clear();
        if (this.profileData?.itemMultiplier.length > 0) {
          this.profileData?.itemMultiplier?.forEach((item: any, index: number) => {
            const group = this.createIMFGroup(index);
            group.patchValue(item);
            this.IMFArray.push(group);
          });
        } else {
          const group = this.createIMFGroup(0);
          // group.patchValue(item);
          this.IMFArray.push(group);
        }
        this.updateNoOfItems();
      } else {
      }
    });
  }

  get zonesFormArray(): FormArray {
    return this.zoneForm.get("zones") as FormArray;
  }

  createZoneForm(zone: any): FormGroup {
    return this.fb.group({
      code: [zone.code],
      name: [zone.name],
      shippingCharge: [zone.shippingCharge, Validators.required],
      minShippingDays: [zone.minShippingDays, Validators.required],
      maxShippingDays: [zone.maxShippingDays, Validators.required],
      currency: [zone.currency || "USD", Validators.required],
    });
  }

  getCurrencyForList() {
    this._uploadService.getCurrency(false).subscribe((res: any) => {
      if (res?.meta?.status == 1) {
        this.currencyList = res?.data;
      }
    });
  }

  // currencyChange(symbol: string, index: number) {
  //   const data = this.currencyList?.find((c: any) => c.symbol === symbol);
  //   if (!data) return;
  //   this.zonesFormArray.at(index).patchValue({
  //     currency: data.currency,
  //   });
  // }

  buildMatrixForm() {
    this.countries?.forEach((origin) => {
      const row = this.fb.group({});
      this.countries?.forEach((destination) => {
        row.addControl(
          destination,
          this.fb.control(
            this.COUNTRY_ZONE_MATRIX[origin][destination],
            Validators.required
          )
        );
      });
      this.originDestinationForm.addControl(origin, row);
    });
  }

  /** Shortcut */
  get IMFArray(): FormArray {
    return this.IMForm?.get("items") as FormArray;
  }

  /** Create single zone group */
  createIMFGroup(i: number): FormGroup {
    return this.fb.group({
      noOfItems: [i + 1, Validators.required],
      outwear: [0, Validators.required],
      top: [0, Validators.required],
      onePiece: [0, Validators.required],
      bottom: [0, Validators.required],
      shoes: [0, Validators.required],
      accessories: [0, Validators.required],
    });
  }

  /** Add zone */
  addIMFGroup(): void {
    this.IMFArray.push(this.createIMFGroup(this.IMFArray.length));
    this.updateNoOfItems();
  }

  /** Remove zone (keep at least one) */
  removeIMFGroup(index: number): void {
    if (this.IMFArray.length > 1) {
      this.IMFArray.removeAt(index);
      this.updateNoOfItems();
    }
  }
  private updateNoOfItems(): void {
    this.IMFArray?.controls?.forEach((control, index) => {
      control.get("noOfItems")?.setValue(index + 1);
    });
  }

  saveZones() {
    const updatedZones: any = this.zonesFormArray.getRawValue();
    if (this.zoneForm.valid) {
      const convertedData = updatedZones?.map((zone) => ({
        ...zone,
        shippingCharge: Number(zone.shippingCharge),
        minShippingdays: Number(zone.minShippingdays),
        maxShippingDays: Number(zone.maxShippingDays),
      }));
      if (this.isPartner) {
        this.updateAccount({ zones: convertedData })
      } else {
        this.saveData({ zones: convertedData });
      }
    }
  }
  saveMatrix() {
    this.isLoad = true;
    const updatedMatrix = this.originDestinationForm.getRawValue();
    if (this.isPartner) {
      this.updateAccount({ originMatrixData: updatedMatrix })
    } else {
      this.saveData({ originMatrixData: updatedMatrix });
    }
    // return updatedMatrix;
  }

  saveItemsData() {
    this.IMForm.markAllAsTouched();

    // Check validity
    if (this.IMForm.invalid) {
      this._helper.toast("Please fill all required fields", "error");
      return; // Stop execution if invalid
    }

    const itemsData = this.IMFArray.getRawValue();

    // Send to backend

    let data: any = itemsData.map((item: any) => {
      const numericItem = {};
      for (const key in item) {
        numericItem[key] = Number(item[key]);
      }
      return numericItem;
    });

    if (this.isPartner) {
      this.updateAccount({ itemMultiplier: data })
    } else {
      this.saveData({ items: data });
    }
  }

  getData() {
    this._configService.view().subscribe((res: any) => {
      if (res?.meta?.status == 1) {
        const zonesArray = this.zonesFormArray;
        res?.data?.zones?.forEach((zone: any, index: number) => {
          if (zonesArray.at(index)) {
            zonesArray.at(index).patchValue({
              shippingCharge: zone.shippingCharge,
              minShippingDays: zone.minShippingDays,
              maxShippingDays: zone.maxShippingDays,
              currency: zone.currency,
            });
          }
        });

        const matrixData = res.data?.originMatrixData ?? {};

        Object.keys(matrixData)?.forEach((origin: any) => {
          const originGroup = this.originDestinationForm?.get(
            origin
          ) as FormGroup;
          if (!originGroup) return;

          Object.keys(matrixData[origin])?.forEach((destination) => {
            if (originGroup?.get(destination)) {
              originGroup
                ?.get(destination)
                ?.patchValue(matrixData[origin][destination]);
            }
          });
        });

        this.IMFArray.clear();
        res?.data?.items?.forEach((item: any, index: number) => {
          const group = this.createIMFGroup(index);
          group.patchValue(item);
          this.IMFArray.push(group);
        });
        this.updateNoOfItems();
      } else {
        this._helper.toast(res?.meta?.message, "error");
      }
    });
  }

  saveData(data: any) {
    this.isLoad = true;
    this._configService.addEdit(data).subscribe(
      (res: any) => {
        if (res?.meta?.status === 1) {
          this.isLoad = false;
          this._helper.toast(res.meta.message, "success");
          this.getData();
        } else {
          this.isLoad = false;
          this._helper.toast(res.meta.message, "error");
        }
      },
      (error) => {
        this.isLoad = false;
      }
    );
  }

  updateAccount(data: any) {
    let getInputsValues = data;
    this._apiService.updateAccount(getInputsValues, this.isPartner).subscribe((res: any) => {
      let user: any = {};
      if (res?.meta?.status == 1) {
        if (!this.isPartner) {
          user = {
            id: res.data?.adminId,
            firstName: res.data.firstName,
            lastName: res.data.lastName,
            email: res.data.email,
            avatar: res.data.profilePicture,
          };
        } else {
          user = {
            id: res.data?.partnerId,
            firstName: res.data.partnerName,
            email: res.data.partnerEmail,
            avatar: res.data.partnerImage,
          };
        }
        this._helper.setLocalStorageData(CommonConstants.USER_DATA, user);
        this._helper.userData.next(user);
        this._helper.toast(res?.meta?.message, "success");
      } else {
        this._helper.toast(res?.meta?.message, "error");
      }
    });
  }

  protected readonly LABELS = LABELS;
}
